import SignUp from '@/components/Auth/Signup'

const RegistrationScreen = () => {
  return <SignUp />
}

export default RegistrationScreen
